import Icon from '../components/Icon';

const RotateRight = Icon(
  'rotate-right',
  <>
    <path d="M9.126 5.07A7.5 7.5 0 0 1 17.301 6.7l.001.001 1.906 1.897h-2.69a.75.75 0 0 0 0 1.5H21a.75.75 0 0 0 .75-.747l.019-4.5a.75.75 0 0 0-1.5-.006l-.011 2.681-1.896-1.886-.001-.001a9 9 0 1 0 0 12.723.75.75 0 0 0-1.06-1.06 7.5 7.5 0 1 1-8.175-12.23" />
  </>
);

export default RotateRight;
